import { formatAnswer } from '../../shared/answerFormat';
import { isAgreement, sectionsOf, spans } from './entryModel';

// One entry's answers in the shapes the downloads need: print cells for the
// PDF (3 columns, wide fields on their own row) and label / answer rows for
// the Excel sheet.

const PRINT_COLUMNS = 3;

const nonBlank = (cells) => cells.some((c) => String(c || '').trim());

// Repeater entries and table rows as [[cell text]] in column order.
export const gridRows = (field, value) => {
  const columns = (field.config && field.config.columns) || [];
  if (field.type === 'repeater') {
    return (Array.isArray(value) ? value : [])
      .map((entry) =>
        columns.map((_, i) =>
          entry && typeof entry === 'object' ? String(entry[i] || '') : ''
        )
      )
      .filter(nonBlank);
  }
  if (!value || typeof value !== 'object') return [];
  const count = Number(field.config && field.config.rows) || 0;
  const rows = [];
  for (let r = 0; r < count; r += 1) {
    rows.push(columns.map((_, c) => String(value[`${r}-${c}`] || '')));
  }
  return rows.filter(nonBlank);
};

const cellOf = (field, value, span) => {
  const base = { label: field.label || 'Untitled field', span };
  if (isAgreement(field)) {
    return { ...base, kind: 'agreement', agreed: value === true };
  }
  if (field.type === 'repeater' || field.type === 'table') {
    return {
      ...base,
      kind: 'grid',
      columns: (field.config && field.config.columns) || [],
      rows: gridRows(field, value),
    };
  }
  return {
    ...base,
    kind: 'text',
    text: formatAnswer(field, value),
    long: field.type === 'long_answer',
  };
};

export const entryPrintSections = (definition, answers) =>
  sectionsOf(definition).map((section) => {
    const sp = spans(section.fields, PRINT_COLUMNS);
    return {
      label: section.label,
      cells: section.fields.map((field, i) =>
        cellOf(field, (answers || {})[field.id], sp[i])
      ),
    };
  });

// [{ section } | { k, v }] for the entry's Excel sheet.
export const entrySheetRows = (definition, answers) => {
  const rows = [];
  sectionsOf(definition).forEach((section) => {
    rows.push({ section: section.label });
    section.fields.forEach((field) => {
      const value = (answers || {})[field.id];
      rows.push({
        k: field.label || 'Untitled field',
        v: isAgreement(field)
          ? value === true
            ? 'Agreed'
            : 'Not agreed'
          : formatAnswer(field, value),
      });
    });
  });
  return rows;
};
